import { useReduxGetter } from "../../../../../common/ui/useReduxGetter";
import { useCallback } from "react";

export default function useReaderReduxGetter(dataSelector, loadStatusSelector) {
  const get = useReduxGetter(dataSelector, loadStatusSelector);

  return useCallback(() => {
    return get()
      .then((result) => ({ ok: true, data: result }))
      .catch(() => ({ ok: false }));
  }, [get]);
}
